import { render, staticRenderFns } from "./TagsField.vue?vue&type=template&id=064feb5e"
import script from "./TagsField.vue?vue&type=script&lang=js"
export * from "./TagsField.vue?vue&type=script&lang=js"
import style0 from "./TagsField.vue?vue&type=style&index=0&id=064feb5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports